/**
 * Animations
 */

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(() => {
    // Function to handle animations
    function setupAnimations() {
        // Animate the first marquee (from right to left)
        gsap.to('.sliding-text__row:nth-child(odd)', {
            x: '-100px', // Move to the left by 100% of the viewport width
            scrollTrigger: {
                trigger: '.sliding-text',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
            }
        });

        // Animate the second marquee (from left to right)
        gsap.to('.sliding-text__row:nth-child(even)', {
            x: '100px', // Move to the right by 100% of the viewport width
            scrollTrigger: {
                trigger: '.sliding-text',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
            }
        });
    }

    // Call the setup function
    setupAnimations();

    // Handle window resize to refresh ScrollTrigger
    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
    });
})